import React, { useState, useEffect } from "react";
import axios from "axios";
import { Redirect, Route } from "react-router-dom";
import UnauthorizedPleaseLoginAgain from "../../containers/OpsContainer/UnauthorizedPleaseLoginAgain";
import { decodeOpAccessToken, decodeWarpAccessToken } from "../../utility";
import { getServiceUrl } from "../../config";
import Spinner from "../../UI/Spinner/Spinner";

const refreshWarpToken = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("tokenId"),
      "Content-Type": "application/json",
      emailId: localStorage.getItem("emailId"),
    },
  };
  try {
    const res = await axios.get(getServiceUrl() + "warp/GetAuthToken", config);
    if (res && res.data) {
      localStorage.setItem("warpToken", res.data);
      return res.data;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const PrivateRoute = ({
  component: Component,
  isCheckedToken = true,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("IsAuthentic") === true ||
      localStorage.getItem("IsAuthentic") === "true" ? (
        isCheckedToken ? (
          <ProtectAuthComponent>
            <Component {...props} />
          </ProtectAuthComponent>
        ) : (
          <Component {...props} />
        )
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

export const OPPrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("IsAuthentic") === true ||
      localStorage.getItem("IsAuthentic") === "true" ? (
        <OPProtectAuthComponent>
          <Component {...props} />
        </OPProtectAuthComponent>
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const isWarpTokenValid = (raw) => {
  if (!raw || raw === "null") return false;
  const decoded = decodeWarpAccessToken(raw);
  return !!decoded && decoded !== "null";
};

const ProtectAuthComponent = ({ children }) => {
  const initial = isWarpTokenValid(localStorage.getItem("warpToken"));
  const [status, setStatus] = useState(initial ? "ok" : "refreshing");

  useEffect(() => {
    if (status !== "refreshing") return;
    let cancelled = false;
    (async () => {
      const fresh = await refreshWarpToken();
      if (cancelled) return;
      setStatus(fresh && isWarpTokenValid(fresh) ? "ok" : "failed");
    })();
    return () => { cancelled = true; };
  }, [status]);

  if (status === "ok") return children;
  if (status === "failed") return <UnauthorizedPleaseLoginAgain />;
  return <Spinner />;
};

const isOpsTokenValid = (raw) => {
  if (!raw || raw === "null") return false;
  const decoded = decodeOpAccessToken(raw);
  return !!decoded && decoded !== "null";
};

const refreshOpsToken = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("tokenId"),
      "Content-Type": "application/json",
      emailId: localStorage.getItem("emailId"),
    },
  };
  try {
    const res = await axios.get(getServiceUrl() + "ops/GetAuthToken", config);
    if (res && res.data) {
      localStorage.setItem("opsToken", res.data);
      return res.data;
    }
    return null;
  } catch (err) {
    return null;
  }
};

const OPProtectAuthComponent = ({ children }) => {
  const initial = isOpsTokenValid(localStorage.getItem("opsToken"));
  const [status, setStatus] = useState(initial ? "ok" : "refreshing");

  useEffect(() => {
    if (status !== "refreshing") return;
    let cancelled = false;
    (async () => {
      const fresh = await refreshOpsToken();
      if (cancelled) return;
      setStatus(fresh && isOpsTokenValid(fresh) ? "ok" : "failed");
    })();
    return () => { cancelled = true; };
  }, [status]);

  if (status === "ok") return children;
  if (status === "failed") return <UnauthorizedPleaseLoginAgain />;
  return <Spinner />;
};
